"use client";

import { useState } from "react";

interface FAQ {
  question: string;
  answer: string;
}

interface FAQAccordionProps {
  faqs: FAQ[];
  categoryIndex: number;
}

export default function FAQAccordion({ faqs, categoryIndex }: FAQAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="space-y-4">
      {faqs.map((faq, index) => {
        const uniqueIndex = `${categoryIndex}-${index}`;
        const isOpen = openIndex === index;

        return (
          <div
            key={uniqueIndex}
            className="bg-white rounded-xl shadow-md hover:shadow-lg transition-all duration-300 border border-gray-100 overflow-hidden"
          >
            <button
              onClick={() => toggleFAQ(index)}
              className="w-full text-left p-6 sm:p-8 flex items-start justify-between gap-4 group"
              aria-expanded={isOpen}
            >
              <div className="flex-1">
                <h3 className="text-lg sm:text-xl font-semibold text-gray-900 group-hover:text-[#7771B8] transition-colors">
                  {faq.question}
                </h3>
              </div>
              <div className="flex-shrink-0 mt-1">
                <div
                  className={`w-8 h-8 rounded-full bg-gray-100 group-hover:bg-[#7771B8] group-hover:text-white flex items-center justify-center transition-all duration-300 ${
                    isOpen ? "bg-[#7771B8] text-white rotate-180" : "text-gray-600"
                  }`}
                >
                  <svg
                    className="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </div>
              </div>
            </button>

            <div
              className={`overflow-hidden transition-all duration-300 ease-in-out ${
                isOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
              }`}
            >
              <div className="px-6 sm:px-8 pb-6 sm:pb-8 pt-0">
                <div className="border-t border-gray-100 pt-6">
                  <p className="text-gray-600 leading-relaxed text-base">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
